import React from "react";
import "./Column.css";
import { columnData } from "../../data/columnData";
import { Link } from "react-router-dom";

const Column: React.FC = () => {
  return (
    <section id="column" className="column-section">
      <div className="column-container">
        <div className="column-left-panel">
          <div className="column-header-flat">
            <h2 className="column-main-title">MOMENTUP COLUMN</h2>
            <p className="column-sub-title">모멘트업이 바라보는 창작의 미래</p>
          </div>
        </div>
        <div className="column-right-panel">
          <div className="column-articles-list">
            {columnData.map((article, index) => (
              <Link
                to={`/column/${article.slug}`}
                key={index}
                className="column-article-item"
              >
                <h3 className="column-article-title">{article.title}</h3>
                <p className="column-article-subtitle text-gray-500">
                  {article.subtitle}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Column;
